import React from 'react';
import { motion } from 'framer-motion';
import { Clock, BatteryWarning, BrainCircuit, Flame, PenTool, MessageSquareWarning } from 'lucide-react';
const problems = [{
  icon: <Clock size={24} data-id="element-294" />,
  title: 'Sin tiempo',
  desc: 'Pasas horas frente a la pantalla intentando redactar un solo post o email.'
}, {
  icon: <BatteryWarning size={24} data-id="element-295" />,
  title: 'Agotamiento de contenido',
  desc: 'Sientes que ya no tienes ideas nuevas y tu creatividad está en cero.'
}, {
  icon: <BrainCircuit size={24} data-id="element-296" />,
  title: 'Confusión con la IA',
  desc: 'ChatGPT te da respuestas robóticas, genéricas y que no suenan a ti.'
}, {
  icon: <Flame size={24} data-id="element-297" />,
  title: 'Burnout digital',
  desc: 'La presión de publicar constantemente te está quemando lentamente.'
}, {
  icon: <PenTool size={24} data-id="element-298" />,
  title: 'Dificultad para crear',
  desc: 'Te cuesta estructurar tus ideas de forma persuasiva y profesional.'
}, {
  icon: <MessageSquareWarning size={24} data-id="element-299" />,
  title: 'Sobre-pensar todo',
  desc: 'Le das mil vueltas a cada caption, email o mensaje de ventas.'
}];
export function Problem() {
  return <section className="py-24 md:py-32 relative border-t border-gold/10 bg-black-100/30" data-id="element-300">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-301">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 md:mb-24" data-id="element-302">
          <h2 className="font-display text-4xl md:text-5xl text-cream mb-6" data-id="element-303">
            El problema real
          </h2>
          <p className="text-cream/60 max-w-2xl mx-auto text-lg font-light" data-id="element-304">
            Deja de perder horas haciendo todo manualmente. La mayoría de los
            profesionales usan la IA como un juguete, no como un sistema.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-305">
          {problems.map((prob, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="group bg-gradient-to-br from-black-200 to-black-100 border border-gold/15 p-8 rounded-sm hover:border-gold/40 hover:from-black-300 hover:to-black-200 transition-all duration-500 relative overflow-hidden shadow-[0_4px_24px_-8px_rgba(0,0,0,0.6)] hover:shadow-[0_8px_32px_-4px_rgba(212,175,122,0.08)]" data-id="element-306">
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent opacity-60" data-id="element-307"></div>
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-gold/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-308"></div>

              <div className="text-gold mb-6 opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500" data-id="element-309">
                {prob.icon}
              </div>
              <h3 className="text-cream text-xl font-medium mb-3" data-id="element-310">
                {prob.title}
              </h3>
              <p className="text-cream/50 font-light leading-relaxed text-sm" data-id="element-311">
                {prob.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}